<template>
  <div class="row">
    <h3 class="text-center">
      <img class="img-rounded" style="width: 2em;" src="img/Bitcoin-Logo.png" alt="Bitcoin" title="Bitcoin"/>
      We accept Bitcoin
      <img class="img-rounded" style="width: 2em;" src="img/Bitcoin-Logo.png" alt="Bitcoin" title="Bitcoin"/>
    </h3>
    <p class="text-center">We will buy bitcoin or you can exchange for goods in store, ask a team member for
      more information</p>
  </div>
</template>
<script>
export default {
  name: 'home-hero-banner'
}
</script>